import Layout from '@/views/Layout';

// 广告主管理

export default {
  name: 'AdvertiserManage',
  path: '/advertiser-manage',
  meta: {
    icon: 'el-icon-news',
    label: '广告主管理',
    isMenu: true,
  },
  component: Layout,
  children: [
    {
      name: 'ProductManage',
      path: 'product-manage',
      meta: {
        label: '我的产品',
        isMenu: true,
      },
      component: () => import('@/views/AdvertiserManage/Product/Index.vue'),
    },
    {
      name: 'AdvertiserManageDetail',
      path: 'detail',
      meta: {
        label: '详情',
        isMenu: false,
        hiddenContentTitle: true,
      },
      component: () => import('@/views/AdvertiserManage/Detail/Detail.vue'),
    },
    {
      name: 'AdvertiserManagePrivate',
      path: 'private',
      meta: {
        label: '私海',
        isMenu: true,
      },
      component: () => import('@/views/AdvertiserManage/Private/Index'),
      children: [
        {
          name: 'AdvertiserManagePrivateList',
          path: '',
          meta: {
            label: '列表',
          },
          component: () => import('@/views/AdvertiserManage/Private/List'),
        },
        {
          name: 'AdvertiserManagePrivateAddAder',
          path: 'add-ader',
          meta: {
            label: '添加广告主',
            hiddenContentTitle: true,
          },
          component: () =>
            import('@/views/AdvertiserManage/Private/AddAdvertiser'),
        },
        {
          name: 'AdvertiserManagePrivateEditAder',
          path: 'edit-ader',
          meta: {
            label: '修改广告主',
            hiddenContentTitle: true,
          },
          component: () => import('@/views/AdvertiserManage/Private/EditAder'),
        },
        {
          name: 'AdvertiserManagePrivateInitAder',
          path: 'init-ader',
          meta: {
            label: '开户',
            hiddenContentTitle: true,
          },
          component: () =>
            import('@/views/AdvertiserManage/Private/InitAdvertiser'),
        },
        {
          name: 'AdvertiserManagePrivateEditAderResult',
          path: 'edit-ader-result',
          meta: {
            label: '修改结果',
            hiddenContentTitle: true,
          },
          component: () =>
            import('@/views/AdvertiserManage/Private/EditResult'),
        },
        {
          name: 'AdvertiserManagePrivateInitAderResult',
          path: 'init-ader-result',
          meta: {
            label: '开户结果',
            hiddenContentTitle: true,
          },
          component: () =>
            import('@/views/AdvertiserManage/Private/InitResult'),
        },
      ],
    },
    {
      name: 'AdvertiserManagePublic',
      path: 'public',
      meta: {
        label: '公海',
        isMenu: true,
      },
      component: () => import('@/views/AdvertiserManage/Public/Index'),
      children: [
        {
          name: 'AdvertiserManagePublicList',
          path: '',
          meta: {
            label: '列表',
          },
          component: () => import('@/views/AdvertiserManage/Public/List'),
        },
      ],
    },
    {
      name: 'AdvertiserManageBelong',
      path: 'belong',
      meta: {
        label: '归属查询',
        isMenu: true,
      },
      component: () => import('@/views/AdvertiserManage/Belong/Index'),
    },
    {
      name: 'AdvertiserManagePublicNotice',
      path: 'public-notice',
      meta: {
        label: '公示查询',
        isMenu: true,
      },
      component: () => import('@/views/AdvertiserManage/PublicNotice/Index'),
    },
    {
      name: 'AdvertiserManageMyInsurance',
      path: 'my-insurance',
      meta: {
        label: '我的客保',
        isMenu: true,
      },
      component: () => import('@/views/AdvertiserManage/MyInsurance/'),
    },
    {
      name: 'AdvertiserManageMyCustomer',
      path: 'my-customer',
      meta: {
        label: '我的客户',
        isMenu: true,
      },
      component: () => import('@/views/AdvertiserManage/MyCustomer/'),
    },
  ],
};
